import { Tr, Td, Radio } from '@chakra-ui/react';
import { cnpjMask } from '../../../../../../utils/cnpjMask';

export function ItemContato({ item, onSelect, isSelected }) {
  return (
    <Tr>
      <Td>{item?.cliente?.codigo_parceiro}</Td>
      <Td fontSize="13px" fontWeight="semibold">
        {item?.cliente?.nome_parceiro}
      </Td>

      <Td fontSize="13px" fontWeight="semibold">
        {item.cliente?.cnpj ? cnpjMask(item.cliente?.cnpj) : item.cliente?.cpf}
      </Td>

      <Td>
        <Radio size="lg" borderColor="#378BBF" onChange={onSelect} isChecked={isSelected} />
      </Td>
    </Tr>
  );
}
